export default {
	namespaced:true,
	actions:{
        
	},
	mutations:{
        
	},
	state:{
        //过程数据
        progressData:[],
		result:[]
	},
	getters:{
        
	},
}